<div
  class="ss-file-drop"
  [class.is-dragging]="dragging"
  [class.is-disabled]="disabled"
  [class.has-error]="message"
  (dragover)="drag($event, true)"
  (dragleave)="drag($event, false)"
  (drop)="drop($event)">
  <input
    #fileInput
    [id]="inputId"
    type="file"
    class="visually-hidden"
    [accept]="accept"
    [disabled]="disabled"
    [attr.aria-describedby]="inputId + '-description'"
    (change)="choose($event)">

  <label [for]="inputId" class="ss-file-drop__target">
    <img *ngIf="previewUrl; else uploadIcon" [src]="previewUrl" alt="Prévia da imagem" class="ss-file-drop__preview">
    <ng-template #uploadIcon>
      <span class="ss-file-drop__icon"><lucide-icon name="cloud-upload" [size]="24" aria-hidden="true"></lucide-icon></span>
    </ng-template>
    <strong>{{ title }}</strong>
    <span [id]="inputId + '-description'">{{ subtitle || (accept ? 'Arquivos permitidos: ' + accept : 'Selecione um arquivo') }}</span>
  </label>

  <div *ngIf="file" class="ss-file-drop__file">
    <lucide-icon name="file-text" aria-hidden="true"></lucide-icon>
    <span class="ss-file-drop__name">{{ file.name }}<small>{{ fileSize }}</small></span>
    <ss-status-chip *ngIf="status !== 'idle'" domain="fileUpload" [value]="status"></ss-status-chip>
    <button type="button" class="ss-btn-icon danger" aria-label="Remover arquivo" [disabled]="disabled" (click)="clear(true)">
      <lucide-icon name="x" aria-hidden="true"></lucide-icon>
    </button>
  </div>

  <progress *ngIf="progressValue > 0" max="100" [value]="progressValue" aria-label="Progresso do envio"></progress>
  <p *ngIf="message" class="ss-file-drop__error" role="alert">{{ message }}</p>
</div>
